import { render, staticRenderFns } from "./BotPlatformsListCard.vue?vue&type=template&id=4206ae36"
import script from "./BotPlatformsListCard.vue?vue&type=script&lang=ts"
export * from "./BotPlatformsListCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports